$(function(){
  setupLoginAndSignupForm();
})

function setupLoginAndSignupForm() {

  // show login form
  $('a.login-show').click(function(e) {
    e.preventDefault();
    $('#loginModal').modal('show');
    $('#loginModal').find('input:first').focus();
  });
  
  $('a.email-login-show').click(function(e) {
    e.preventDefault();
    $('#loginModal').modal('hide');
    $('#emailLoginModal').modal('show');
    $('#emailLoginModal').find('input:first').focus();
  });
  $('a.email-login-hide').click(function(e) {
    e.preventDefault();
    $('#emailLoginModal').modal('hide');
    $('#loginModal').modal('show');
    $('#loginModal').find('input:first').focus();
  });

  // show signup form
  $('a.signup-show').click(function(e) {
    e.preventDefault();
    $('#signupModal').modal('show');
  });

  // toggle (switch between login and signup form)
  $('#loginModal, #signupModal').on('click', 'a.login-signup-toggle', function(e) {
      e.preventDefault();
      $('#loginModal').modal('toggle'); 
      $('#signupModal').modal('toggle'); 
    });
  $('.signupWithPaymentForm').on('click', 'a.login-signup-toggle', function(e) {
      e.preventDefault();
      $('#loginModal').modal('toggle'); 
      $('#loginModal').find('input[name=redirect]').attr('value', 'payment');
  });
}
